import axios from '@/services/httpClient';
import { useAuthStore } from '@/stores/authStore';

async function withRetry(requestFactory, retryAttempt = false) {
  const authStore = useAuthStore();

  try {
    const response = await requestFactory(authStore);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401 && !retryAttempt) {
      await authStore.refreshAccessToken();
      return withRetry(requestFactory, true);
    }
    throw error;
  }
}

export const getAdminStateSummary = async ({ state, start_date, end_date }) => withRetry((authStore) =>
  axios.get('/nora_superadmin/state-comparison/summary', {
    params: {
      state,
      start_date,
      end_date,
    },
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const getAdminStateClinics = async ({ state, start_date, end_date, sort, order }) => withRetry((authStore) =>
  axios.get('/nora_superadmin/state-comparison/clinics', {
    params: {
      state,
      start_date,
      end_date,
      sort,
      order,
    },
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const getAdminStateClinicDetail = async ({ location_uuid, start_date, end_date }) => withRetry((authStore) =>
  axios.get(`/nora_superadmin/state-comparison/clinic/${location_uuid}`, {
    params: {
      start_date,
      end_date,
    },
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const getStateOrgSummary = async ({ start_date, end_date }) => withRetry((authStore) =>
  axios.get('/nora_state_org/dashboard/summary', {
    params: {
      start_date,
      end_date,
    },
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const getStateOrgClinicDetail = async ({ location_uuid, start_date, end_date }) => withRetry((authStore) =>
  axios.get(`/nora_state_org/dashboard/clinic/${location_uuid}`, {
    params: {
      start_date,
      end_date,
    },
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const getStateOrgClinics = async ({ start_date, end_date, sort, order }) => withRetry((authStore) =>
  axios.get('/nora_state_org/dashboard/clinics', {
    params: {
      start_date,
      end_date,
      sort,
      order,
    },
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

function serializeLocationUuids(location_uuids) {
  if (location_uuids === undefined || location_uuids === null) {
    return undefined;
  }
  if (Array.isArray(location_uuids)) {
    return location_uuids.length ? location_uuids.join(',') : 'none';
  }
  return location_uuids || 'none';
}

export const getStateOrgTrends = async ({ start_date, end_date, location_uuids }) => withRetry((authStore) =>
  axios.get('/nora_state_org/dashboard/trends', {
    params: {
      start_date,
      end_date,
      location_uuids: serializeLocationUuids(location_uuids),
    },
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);

export const getStateOrgOverview = async ({ start_date, end_date, location_uuids, sort, order }) => withRetry((authStore) =>
  axios.get('/nora_state_org/dashboard/overview', {
    params: {
      start_date,
      end_date,
      location_uuids: serializeLocationUuids(location_uuids),
      sort,
      order,
    },
    headers: {
      Authorization: `Bearer ${authStore.accessToken}`,
    },
  })
);
